export default {
  backgroundColor: '#FFF',
};
